import React from "react";
import useInView from "../../../hooks/useInView";
import "./TarjetaDeServicioIncident.css";

interface ServiceItem {
  title: string;
  desc: string;
}

interface TarjetaDeServicioIncidentProps {
  service: ServiceItem;
  delay?: number;
  animationClass?: string;
}

export default function TarjetaDeServicioIncident({ service, delay = 0, animationClass = "" }: TarjetaDeServicioIncidentProps) {
  const [ref, inView] = useInView({ threshold: 0.3 });

  return (
    <div
      ref={ref}
      className={`serviceincident-card animate-card${inView ? " visible" : ""} ${animationClass}`}
      style={{ transitionDelay: `${delay}s` } as React.CSSProperties}
    >
      <h3 className="serviceincident-card-title">{service.title}</h3>
      <p className="serviceincident-card-text">{service.desc}</p>
    </div>
  );
}